<template>
  <div id="app">
    <Header />
    <main>
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  watch: {
    '$i18n.locale'() {
      this.updateMeta()
    },
    '$route'() {
      this.updateMeta()
    }
  },
  mounted() {
    this.updateMeta()
  },
  methods: {
    updateMeta() {
      // 更新页面标题
      document.title = this.$t('meta.title')

      // 更新meta描述
      const descriptionMeta = document.querySelector('meta[name="description"]')
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', this.$t('meta.description'))
      }

      // 更新meta关键词
      const keywordsMeta = document.querySelector('meta[name="keywords"]')
      if (keywordsMeta) {
        keywordsMeta.setAttribute('content', this.$t('meta.keywords'))
      }

      // 更新语言相关meta标签
      const languageMeta = document.querySelector('meta[name="language"]')
      if (languageMeta) {
        languageMeta.setAttribute('content', this.$i18n.locale)
      }

      // 更新Open Graph meta标签
      this.updateOgMeta('og:title', this.$t('meta.title'))
      this.updateOgMeta('og:description', this.$t('meta.description'))
      this.updateOgMeta('og:locale', this.$i18n.locale === 'zh-CN' ? 'zh_CN' : 'en_US')

      // 更新Twitter Card meta标签
      this.updateOgMeta('twitter:title', this.$t('meta.title'))
      this.updateOgMeta('twitter:description', this.$t('meta.description'))

      // 添加结构化数据
      this.updateStructuredData()

      // 更新html lang属性
      document.documentElement.lang = this.$i18n.locale
    },

    updateOgMeta(property, content) {
      let meta = document.querySelector(`meta[property="${property}"]`) ||
                 document.querySelector(`meta[name="${property}"]`)

      if (!meta) {
        meta = document.createElement('meta')
        if (property.startsWith('og:') || property.startsWith('twitter:')) {
          meta.setAttribute('property', property)
        } else {
          meta.setAttribute('name', property)
        }
        document.head.appendChild(meta)
      }

      meta.setAttribute('content', content)
    },

    updateStructuredData() {
      // 移除现有的结构化数据
      const existingScript = document.querySelector('script[type="application/ld+json"]')
      if (existingScript) {
        existingScript.remove()
      }

      // 添加新的结构化数据
      const structuredData = this.$t('meta.structuredData')
      if (structuredData) {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.textContent = JSON.stringify(structuredData)
        document.head.appendChild(script)
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}
</style>
